import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastsService {

  constructor(private toastr: ToastrService) { }

  showSucces(title: string, text: string) {
    return this.toastr.success(text, title, {
      enableHtml: true
    });
  }

  showInfo(title: string, text: string) {
    return this.toastr.info(text, title, {
      enableHtml: true
    });
  }

  showWarning(title: string, text: string) {
    return this.toastr.warning(text, title, {
      enableHtml: true
    });
  }

  showDanger(title: string, text: string) {
    return this.toastr.error(text, title, {
      enableHtml: true
    });
  }


  showCalibrationWarning(data: any) {

  const html = `
    <div class="cron-notification">

      <div class="cron-icon warning">
        <i class="mdi mdi-calendar-clock"></i>
      </div>

      <div class="cron-content">

        <div class="cron-title">
          Calibración próxima a vencer
        </div>

        <div class="cron-message">
          ${data.message}
        </div>

        <div class="cron-details">

          <span>
            <i class="mdi mdi-calendar"></i>
            ${data.calibrationValidity}
          </span>

          <span>
            <i class="mdi mdi-clock-outline"></i>
            ${data.daysRemaining} días restantes
          </span>

        </div>

      </div>

    </div>
  `;

  return this.toastr.warning(
    html,
    '',
    {
      enableHtml: true,
      timeOut: 10000,
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-top-right'
    }
  );
}

showCalibrationExpired(data: any) {

  const html = `
    <div class="cron-notification">

      <div class="cron-icon danger">
        <i class="mdi mdi-alert-circle"></i>
      </div>

      <div class="cron-content">

        <div class="cron-title">
          Calibración vencida
        </div>

        <div class="cron-message">
          ${data.message}
        </div>

        <div class="cron-details">

          <span>
            <i class="mdi mdi-calendar-remove"></i>
            ${data.calibrationValidity}
          </span>

          <span>
            Equipo: ${data.equipmentKey}
          </span>

        </div>

      </div>

    </div>
  `;

  return this.toastr.error(
    html,
    '',
    {
      enableHtml: true,
      timeOut: 15000,
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-top-right'
    }
  );
}
}